import { render, staticRenderFns } from "./CloneBuildingConfiguration.vue?vue&type=template&id=3c07db82&"
import script from "./CloneBuildingConfiguration.vue?vue&type=script&lang=js&"
export * from "./CloneBuildingConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports